class CollectionCalloutVideo extends HTMLElement {
    constructor() {
        super();
        this.handlePlayVideo = this.handlePlayVideo.bind(this);
    }

    connectedCallback() {
        this.initVideoCallout();
    }

    initVideoCallout() {
        this.videoElement = this.querySelector('video');
        this.playButton = this.querySelector('.play-button');

        if (this.videoElement) {
            this.videoElement.addEventListener('click', this.handlePlayVideo);

            this.videoElement.addEventListener('play', () => {
                if (this.hasInteracted && this.playButton) {
                    this.playButton.style.display = 'none';
                }
            });

            this.videoElement.addEventListener('pause', () => {
                if (this.hasInteracted && this.playButton) {
                    this.playButton.style.display = 'block';
                }
            });
        }

        if (this.playButton) {
            this.playButton.addEventListener('click', this.handlePlayVideo);
        }
    }

    handlePlayVideo(event) {
        event.stopPropagation();
        if (!this.videoElement) return;

        if (!this.hasInteracted) {
            this.videoElement.muted = false;
            this.videoElement.controls = true;
            this.hasInteracted = true;

            if (this.playButton) {
                this.playButton.style.display = 'none';
            }

            this.videoElement.play();
            return;
        }

        if (this.videoElement.paused) {
            this.videoElement.play();
            this.playButton.style.display = 'none';
        } else {
            this.videoElement.pause();
            this.playButton.style.display = 'block';
        }
    }

}

customElements.define('collection-callout-video', CollectionCalloutVideo);